const mutationCallback = cbFunc => mutations => mutations.forEach(cbFunc);
const mutationObserver = cbFunc => new MutationObserver(mutationCallback(cbFunc));

export default mutationObserver;
